import "../scss/styles.scss";

import onChange from 'on-change';

import calc from './calc';
import { render, renderSwitchPmi, renderSwitchTax, renderSwitchAdditional, legendSetColors } from './render';
import {tabsModalStart} from "./function";
import htmlTemplateForm from "./htmlTemplateForm";

// controller

// watch exclude changes
const updateExclude = (form, watchedState) => {
  const excludesElements = form.querySelectorAll('[data-calc-exclude]');
  const { exclude } = watchedState.form;

  [...excludesElements].forEach((excludeItem) => {
    const { checked } = excludeItem;
    const { calcExclude } = excludeItem.dataset;
    const calcExcludeCollection = calcExclude.split(',');

    calcExcludeCollection.forEach((name) => {
      exclude[name] = checked;
    });
  });
};

// watch switcher changes
const updateSwitch = (form, watchedState) => {
  const excludesElements = form.querySelectorAll('.switcher');
  const { switches } = watchedState.form;

  for (let i = 0; i < excludesElements.length; i++) {
    excludesElements[i].addEventListener('change', function() {
      let siblingInput = excludesElements[i].parentNode.parentNode.parentNode.querySelector('.input');
      siblingInput.value = '';

      if (excludesElements[i].value === '$') {
        if(siblingInput.name === 'down-payment'){
          siblingInput.step = '1000';
          siblingInput.placeholder = '1000';
        }
        if(siblingInput.name === 'pmi-rate'){
          siblingInput.step = '100';
          siblingInput.placeholder = '100';
        }
        if(siblingInput.name === 'property-tax'){
          siblingInput.step = '1000';
          siblingInput.placeholder = '1000';
        }
        if(siblingInput.name === 'home-insurance'){
          siblingInput.step = '100';
          siblingInput.placeholder = '100';
        }
      } else {
        if(siblingInput.name === 'down-payment'){
          siblingInput.step = '0.5';
          siblingInput.placeholder = '0.5';
        }
        if(siblingInput.name === 'pmi-rate'){
          siblingInput.step = '0.1';
          siblingInput.placeholder = '0.1';
        }
        if(siblingInput.name === 'property-tax'){
          siblingInput.step = '0.1';
          siblingInput.placeholder = '0.1';
        }
        if(siblingInput.name === 'home-insurance'){
          siblingInput.step = '0.1';
          siblingInput.placeholder = '0.1';
        }
      }
    });
  }

  [...excludesElements].forEach((excludeItem) => {
    switch (excludeItem.checked) {
      case true:
        switches[excludeItem.name] = excludeItem.value;
        break;
      case false:
        break;
      default:
        break;
    }
  });
};


const updateValues = (elements, watchedState) => {
  const { values } = watchedState.form;
  const { form } = elements;
  const formData = new FormData(form);

  // update values
  [...formData.entries()].forEach(([key, value]) => {
    if (key in values) {
      values[key] = value === '' ? 0 : +value;
      // console.log(values[key])
    }
  });

  // update exclude list
  updateExclude(form, watchedState);
};
const updateUserValues = (elements, watchedState) => {
  const { user } = watchedState.form;
  const { form } = elements;
  const formData = new FormData(form);

  // update values
  [...formData.entries()].forEach(([key, value]) => {
    if (key in user) {
      user[key] = value;
      // console.log(values[key])
    }
  });

  // update exclude list
  updateExclude(form, watchedState);
};

const init = () => {

  const isTemplate = htmlTemplateForm();
  tabsModalStart();

  if(!isTemplate) {
    return false;
  }

  // MODEL
  const elements = {
    form: document.forms.calc,
    formRerender: document.getElementById('rerender'),
    modalSending: document.getElementById('modalSendResult'),
    resultMortgageAmount: document.querySelector('[data-calc-result="amount"]'),
    resultTotalCost: document.querySelector('[data-calc-result="total"]'),
    resultMonthlyPayment: document.querySelector('[data-calc-result="monthly"]'),
    switchPmiBlock: document.querySelectorAll('[data-pmi-rate]'),
    switchTaxesBlock: document.querySelectorAll('[data-property-tax]'),
    switchAdditionalBlock: document.querySelectorAll('[data-additional-insurance]'),

    // switchers
    switchTaxes: document.querySelectorAll('[data-switch="switch-property"]'),
    switchDownPayment: document.querySelectorAll('[data-switch="switch-down-payment"]'),
    switchHomeInsurance: document.querySelectorAll('[data-switch="switch-home-insurance"]'),
    switchPMI: document.querySelectorAll('[data-switch="switch-mortgage"]'),
    // switchInsurance: document.querySelectorAll('[data-switch="switch-insurance"]'),
    // switchPmi: document.querySelectorAll('[data-switch="switch-pmi"]'),

    // for donut
    donutBox: document.querySelector('[data-calc="donut"]'),
    donutLegendItems: document.querySelectorAll('[data-calc-legend-name]'),

    // sending status
    success: document.querySelector('.form-send__status-ok'),
    error: document.querySelector('.form-send__status-fail'),
  };

  // MODEL
  const state = {
    form: {
      user: {
        'name': '',
        'email': '',
        'phone': '',
      },
      values: {
        'home-price': null,
        'down-payment': null,
        'interest-rate': null,
        'home-insurance': null,
        'property-tax': null,
        'pmi-rate': null,
        'additional-insurance': null,
        'hoa-dues': null,
        'term': null,
      },
      switches: {
        'switch-property': '$',
        'switch-down-payment': '$',
        'switch-additional': '$',
        'switch-mortgage': '%',
      },
      exclude: {
        'home-insurance': null,
        'pmi-rate': null,
        'property-tax': null,
        'additional-insurance': null,
      },
    },
    result: {
      'mortgage-amount': null,
      'monthly-payment': null,
      'mortgage-insurance': null,
      'mortgage-total-cost': null,
    },
    donutData: [
      {
        key: 'pi',
        name: 'P&I',
        color: '#C6983D',
        data: null,
      },
      {
        key: 'insurance',
        name: 'Insurance',
        color: '#4D4D4D',
        data: null,
      },
      {
        key: 'taxes',
        name: 'Taxes',
        color: '#D3E2EE',
        data: null,
      },
      {
        key: 'pmi',
        name: 'MI',
        color: '#F2F2F2',
        data: null,
      },
      {
        key: 'hoa',
        name: 'HOA',
        color: '#E9C988',
        data: null,
      },
    ],
  };

  // MODEL
  const watchedState = onChange(state, (path, value) => {
    switch (path) {
      case 'form.exclude.pmi-rate':
        renderSwitchPmi(elements, value);
        break;
      case 'form.exclude.property-tax':
        renderSwitchTax(elements, value);
        break;
      case 'form.exclude.additional-insurance':
        renderSwitchAdditional(elements, value);
        break;

      default:
        break;
    }

    calc(elements, watchedState);
  });

  // CONTROLLER
  const { form, formRerender, modalSending } = elements;
  const { result } = watchedState;
  const { values, user } = watchedState.form;

  formRerender.addEventListener('click', (e) => {
    e.preventDefault();
    // updateValues(elements, watchedState);
    // updateSwitch(form, watchedState);
    // legendSetColors(elements, watchedState);
    render(elements, watchedState);
  });

  form.addEventListener('change', () => {
    updateValues(elements, watchedState);
    updateSwitch(form, watchedState);

    render(elements, watchedState);
  });

  // Data sending
  form.addEventListener('submit', (e) => {
    e.preventDefault();
    updateValues(elements, watchedState);
    updateUserValues(elements, watchedState);

    let submitter = e.submitter,
        submitCurrentText = submitter.innerHTML,
        submitWaitText = submitter.dataset.wait,
        submitErrorText = submitter.dataset.error,
        submitSuccessText = submitter.dataset.success;

    let formData = {
      // form id
      "form_id": elements.form.id,
      // user data
      "name": user["name"],
      "email": user["email"],
      "phone": user["phone"],
      // input data
      "home_price": values["home-price"],
      "down_payment": values["down-payment"],
      "interest_rate": values["interest-rate"],
      "home_insurance": values["home-insurance"],
      "property_tax": values["property-tax"],
      "pmi_rate": values["pmi-rate"],
      "additional_insurance": values["additional-insurance"],
      "hoa_dues": values["hoa-dues"],
      "term": values["term"],
      // results
      "mortgage_amount": result["mortgage-amount"],
      "monthly_payment": result["monthly-payment"],
      "mortgage_insurance": result["mortgage-insurance"],
      "mortgage_total_cost": result["mortgage-total-cost"],
    };
    // ***
    if(user["email"] !== ''){
      submitter.innerHTML = submitWaitText;
      fetch("https://digitalbutlers.me/any_scripts/ligolab/sheets/test/send_results.php", {
        method: "POST",
        body: JSON.stringify(formData),
        // body: formData,
      }).then(function (response) {
        if (response.status === 200){
          submitter.innerHTML = submitSuccessText;
          setTimeout(function () {
            modalSending.classList.remove('open');
            document.body.classList.remove("no-scroll");
            submitter.innerHTML = submitCurrentText;
            form.reset();
          }, 1000)
        } else {
          submitter.innerHTML = submitErrorText;
          setTimeout(function () {
            modalSending.classList.remove('open');
            document.body.classList.remove("no-scroll");
            form.reset();
            submitter.innerHTML = submitCurrentText;
          }, 1000)
        }
      }).catch(function (error) {
        submitter.innerHTML = submitErrorText;
        console.log(error);
      });
    } else {
      submitter.innerHTML = submitErrorText;
      setTimeout(function () {
        modalSending.classList.remove('open');
        document.body.classList.remove("no-scroll");
        form.reset();
        submitter.innerHTML = submitCurrentText;
      }, 1000)
    }
  });

  // FIRST START
  updateValues(elements, watchedState);
  updateSwitch(form, watchedState);

  render(elements, watchedState);
  legendSetColors(elements, watchedState);
};

init();
